import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlatformModule } from '@angular/cdk/platform';
import { CoreRoutingModule } from './core-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthenticationInterceptor } from './interceptors/authentication.interceptor';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router'
import { SuiModule } from '@richardlt/ng2-semantic-ui';
import { SharedModule } from '../shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { AuthenticationService } from './services/authentication.service';
import {
  AppLayoutComponent,
  HeaderComponent,
  SidebarComponent,
  PublicHeaderComponent,
  PublicLayoutComponent,
} from './Components';
import { AuthGuard } from './guards/auth.guard';
import { RedirectInterceptor } from './interceptors/redirect.interceptor';


const CORE_MODULES: Array<any> = [
  CommonModule,
  HttpClientModule,
  ReactiveFormsModule,
  FormsModule,
  RouterModule,
  BrowserModule
];

const CORE_SERVICES: Array<any> = [AuthenticationService];


@NgModule({
  declarations: [
    HeaderComponent,
    SidebarComponent,
    AppLayoutComponent,
    PublicHeaderComponent,
    PublicLayoutComponent
  ],
  imports: [
    ...CORE_MODULES,
    CoreRoutingModule,
    SharedModule,
    PlatformModule,
  ],
  exports: [...CORE_MODULES]
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthenticationInterceptor,
          multi: true
        },
        {
					provide: HTTP_INTERCEPTORS,
					useClass: RedirectInterceptor,
					multi: true,
				},
        ...CORE_SERVICES,
        AuthenticationService,
        AuthGuard
      ],
    };
  }
}
